import { componentDataFetcher } from 'redux/fetchers/component-data';
import { navigationFetcher } from 'redux/fetchers/navigation';
import { cmsPageFetcher } from 'redux/fetchers/cms-page';
import { all } from 'route-data/all';
import { chain } from 'route-data/chain';
import { createFetcherChain } from 'route-data/common-fetch';

export { default } from './CmsPage';

export const cmsPageParallelFetcher = createFetcherChain({
  fetchersInParallel: all(chain(cmsPageFetcher, componentDataFetcher), navigationFetcher),
});
